import {useCallback, useEffect, useState} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import fetchCountriesDictionary from '@/src/signUp/emailStep/utils/fetchCountriesDictionary';
import fetchCountriesDictionaryWithClinics from '@/src/signUp/emailStep/utils/fetchCountriesDictionaryWithClinics';
import fetchCountriesDictionaryWithFollowers from '@/src/signUp/emailStep/utils/fetchCountriesDictionaryWithFollowers';
import fetchCountriesDictionaryWithFollowing from '@/src/signUp/emailStep/utils/fetchCountriesDictionaryWithFollowing';
import fetchCountriesDictionaryWithUsers from '@/src/signUp/emailStep/utils/fetchCountriesDictionaryWithUsers';
import fetchCountriesDictionaryWithVacancies from '@/src/signUp/emailStep/utils/fetchCountriesDictionaryWithVacancies';

export enum LocationTypes {
  WITH_USERS = 'withUsers',
  WITH_VACANCY = 'withCountries',
  WITH_CLINICS = 'withClinics',
  WITH_FOLLOWERS = 'withFollowers',
  WITH_FOLLOWING = 'withFollowing',
  ALL = 'all',
}

export type LocationType =
  | LocationTypes.WITH_USERS
  | LocationTypes.WITH_VACANCY
  | LocationTypes.WITH_CLINICS
  | LocationTypes.ALL
  | LocationTypes.WITH_FOLLOWERS
  | LocationTypes.WITH_FOLLOWING;

const METHODS = {
  [LocationTypes.ALL]: fetchCountriesDictionary,
  [LocationTypes.WITH_VACANCY]: fetchCountriesDictionaryWithVacancies,
  [LocationTypes.WITH_CLINICS]: fetchCountriesDictionaryWithClinics,
  [LocationTypes.WITH_USERS]: fetchCountriesDictionaryWithUsers,
  [LocationTypes.WITH_FOLLOWERS]: fetchCountriesDictionaryWithFollowers,
  [LocationTypes.WITH_FOLLOWING]: fetchCountriesDictionaryWithFollowing,
};

const useCountriesList = (
  countriesType: LocationType = LocationTypes.ALL,
  userId = null
) => {
  const [countriesList, setCountriesList] = useState([]);

  useEffect(() => {
    getCountries(countriesType);
  }, [countriesType]);

  const getCountries = useCallback(
    async (countriesType: LocationType) => {
      const {responseBody, status} = await METHODS[countriesType](userId);

      if (status === RESPONSE_STATUSES.SUCCESS) {
        setCountriesList(responseBody.data);
      }
    },
    [countriesList]
  );

  return {
    countriesList,
  };
};

export default useCountriesList;
